module.exports = __webpack_public_path__ + "img/02.a8cfc93c.jpg";